(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("riot"));
	else if(typeof define === 'function' && define.amd)
		define(["riot"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("riot")) : factory(root["riot"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _opts = __webpack_require__(9);

Object.keys(_opts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _opts[key];
    }
  });
});

var _transition = __webpack_require__(10);

Object.keys(_transition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _transition[key];
    }
  });
});

var _listener = __webpack_require__(11);

Object.keys(_listener).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _listener[key];
    }
  });
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrays__ = __webpack_require__(3);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "array", function() { return __WEBPACK_IMPORTED_MODULE_0__arrays__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trees__ = __webpack_require__(14);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tree", function() { return __WEBPACK_IMPORTED_MODULE_1__trees__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strings__ = __webpack_require__(15);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "string", function() { return __WEBPACK_IMPORTED_MODULE_2__strings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin__ = __webpack_require__(16);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deepMix", function() { return __WEBPACK_IMPORTED_MODULE_3__mixin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css__ = __webpack_require__(17);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "css", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__printer__ = __webpack_require__(18);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "printer", function() { return __WEBPACK_IMPORTED_MODULE_5__printer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objects__ = __webpack_require__(19);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_6__objects__["a"]; });








/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return array; });


var array = function array(self) {
    return {
        last: function last() {
            return self.length > 0 ? self[self.length - 1] : null;
        },
        "in": function _in(arr, otherCondition) {
            return self.filter(function (elt) {
                return arr.indexOf(elt) >= 0 && (!otherCondition || otherCondition(elt));
            });
        },
        notIn: function notIn(arr, otherCondition) {
            return self.filter(function (elt) {
                return arr.indexOf(elt) < 0 && (!otherCondition || otherCondition(elt));
            });
        },
        is: function is(_ref, otherCondition) {
            var _ref$isIn = _ref.isIn,
                isIn = _ref$isIn === undefined ? [] : _ref$isIn,
                _ref$notIn = _ref.notIn,
                notIn = _ref$notIn === undefined ? [] : _ref$notIn;
            return self.filter(function (elt) {
                return isIn.reduce(function (acc, curr) {
                    return curr.indexOf(elt) >= 0 && acc;
                }, true) && notIn.reduce(function (acc, curr) {
                    return curr.indexOf(elt) < 0 && acc;
                }, true) && (!otherCondition || otherCondition(elt));
            });
        },
        contains: function contains(element) {
            return self.indexOf(element) >= 0;
        },
        allIn: function allIn(arr) {
            return self.every(function (elt) {
                return arr.indexOf(elt) >= 0;
            });
        }
    };
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic__ = __webpack_require__(20);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return __WEBPACK_IMPORTED_MODULE_0__logic__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RootNode", function() { return __WEBPACK_IMPORTED_MODULE_0__logic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strategies__ = __webpack_require__(6);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectionStrategies", function() { return __WEBPACK_IMPORTED_MODULE_1__strategies__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clickStrategies", function() { return __WEBPACK_IMPORTED_MODULE_1__strategies__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldStrategies", function() { return __WEBPACK_IMPORTED_MODULE_1__strategies__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults__ = __webpack_require__(7);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_2__defaults__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dragndrop__ = __webpack_require__(5);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dragndrop", function() { return __WEBPACK_IMPORTED_MODULE_3__dragndrop__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_3__dragndrop__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "nodeEvents", function() { return __WEBPACK_IMPORTED_MODULE_3__dragndrop__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrapEvents", function() { return __WEBPACK_IMPORTED_MODULE_3__dragndrop__["d"]; });





/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dragndrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nodeEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wrapEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



// Drag and drop presets //

var dragndrop = {
    // Moves the selection //
    selection: function selection(model, cb) {
        return {
            draggable: true,
            droppable: true,
            drag: function drag(item, event, inputs) {
                event.dataTransfer && event.dataTransfer.setData("application/json", JSON.stringify(inputs.selection));
            },
            guard: function guard(target, event, inputs) {
                // Other data types
                if (event && event.dataTransfer && event.dataTransfer.types.indexOf("application/json") < 0) return false;
                // Prevent drop on self
                var selfDrop = function selfDrop() {
                    return target && Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(inputs.selection).contains(target);
                };
                // Prevent drop on child
                var childDrop = function childDrop() {
                    return inputs.ancestors && inputs.ancestors.reduce(function (prev, curr) {
                        return prev || Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(inputs.selection).contains(curr);
                    }, false);
                };

                return selfDrop() || childDrop();
            },
            drop: function drop(target, event, inputs) {
                var updatedModel = Object(__WEBPACK_IMPORTED_MODULE_0__tools__["tree"])(model(), inputs.category).filter(function (e) {
                    return inputs.selection.indexOf(e) < 0;
                });
                var adjustedTarget = target ? target[inputs.category] && target[inputs.category] instanceof Array ? target : Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(inputs.ancestors).last() : null;
                if (adjustedTarget) adjustedTarget[inputs.category] = [].concat(_toConsumableArray(adjustedTarget[inputs.category]), _toConsumableArray(inputs.selection));else updatedModel = [].concat(_toConsumableArray(updatedModel), _toConsumableArray(inputs.selection));
                cb(updatedModel);
            }
        };
    },
    // Plucks an item on drag
    pluck: function pluck(model, cb) {
        return {
            draggable: true,
            backup: [],
            drag: function drag(item, event, inputs) {
                bak = JSON.stringify(model());
                event.dataTransfer && event.dataTransfer.setData("application/json", JSON.stringify(item));
                setTimeout(function () {
                    return cb(Object(__WEBPACK_IMPORTED_MODULE_0__tools__["tree"])(model(), inputs.category).filter(function (e) {
                        return e !== item;
                    }));
                }, 20);
            },
            cancel: function cancel() {
                cb(JSON.parse(bak));
            }
        };
    },
    // Pastes item(s) on drop
    paste: function paste(model, cb) {
        return {
            droppable: true,
            drop: function drop(target, event, inputs) {
                if (event.dataTransfer && event.dataTransfer.types.indexOf("application/json") > -1) {
                    var data = JSON.parse(event.dataTransfer.getData("application/json"));
                    var updatedModel = [].concat(_toConsumableArray(model()));
                    var adjustedTarget = target ? target[inputs.category] && target[inputs.category] instanceof Array ? target : Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(inputs.ancestors).last() : null;
                    if (adjustedTarget) adjustedTarget[inputs.category] = [].concat(_toConsumableArray(adjustedTarget[inputs.category]), [data]);else updatedModel = [].concat(_toConsumableArray(updatedModel), [data]);
                    cb(updatedModel);
                }
            }
        };
    }
};
var bak = "[]";

// Utils

var utils = {
    // Returns a list of local files/folders dropped
    filesystem: function filesystem(event) {
        var items = event.dataTransfer ? event.dataTransfer.items : null;
        if (items && items.length > 0 && items[0].kind === "file") {
            var files = [];
            for (var i = 0; i < items.length; i++) {
                /* eslint-disable */
                var item = items[i].webkitGetAsEntry() || items[i].getAsFile();
                /* eslint-enable */
                if (item) {
                    files.push(item);
                }
            }
            return files;
        }
        return null;
    }

    // Internal use //

};var hoverReferences = {
    itemRef: undefined,
    guardCheck: false
};
var nodeEvents = {
    onDragStart: function onDragStart(item) {
        return function (event) {
            event.stopPropagation();
            this.inputs.get().dragndrop.onDrag(item, event, this.inputs.get());
        };
    },
    onDragOver: function onDragOver(item) {
        return function (event) {
            event.preventDefault();
            event.stopPropagation();

            var guardCheck = hoverReferences.itemRef === item ? hoverReferences.guardCheck : this.inputs.get().dragndrop.guard && this.inputs.get().dragndrop.guard(item, event, this.inputs.get());

            if (guardCheck) {
                if (event.dataTransfer) event.dataTransfer.dropEffect = "none";
                __WEBPACK_IMPORTED_MODULE_0__tools__["css"].addClass(event.currentTarget, this.mixCss("nodrop"));
            } else {
                if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
                __WEBPACK_IMPORTED_MODULE_0__tools__["css"].addClass(event.currentTarget, this.mixCss("dragover"));
            }

            hoverReferences.itemRef = item;
            hoverReferences.guardCheck = guardCheck;

            this.inputs.get().dragndrop.onOver(item, event, this.inputs.get());
        };
    },
    onDragEnter: function onDragEnter(item) {
        return function (event) {
            event.preventDefault();
            event.stopPropagation();
            // If dragging over an opener
            if (item && (this.hasChildren(item) || this.isAsync(item)) && __WEBPACK_IMPORTED_MODULE_0__tools__["css"].hasClass(event.target, this.mixCss("opener"))) {
                var newVal = this.state.get().unfolded.filter(function (i) {
                    return i !== item;
                });
                newVal.push(item);
                this.state.set({ unfolded: newVal });
            }

            this.inputs.get().dragndrop.onEnter(item, event, this.inputs.get());
        };
    },
    onDragLeave: function onDragLeave(item) {
        return function (event) {
            event.stopPropagation();
            __WEBPACK_IMPORTED_MODULE_0__tools__["css"].removeClass(event.currentTarget, this.mixCss("dragover"));
            __WEBPACK_IMPORTED_MODULE_0__tools__["css"].removeClass(event.currentTarget, this.mixCss("nodrop"));

            this.inputs.get().dragndrop.onLeave(item, event, this.inputs.get());
        };
    },
    onDrop: function onDrop(item) {
        return function (event) {
            event.stopPropagation();
            __WEBPACK_IMPORTED_MODULE_0__tools__["css"].removeClass(event.currentTarget, this.mixCss("dragover"));
            __WEBPACK_IMPORTED_MODULE_0__tools__["css"].removeClass(event.currentTarget, this.mixCss("nodrop"));
            if (!this.inputs.get().dragndrop.guard || !this.inputs.get().dragndrop.guard(item, event, this.inputs.get())) {
                this.inputs.get().dragndrop.onDrop(item, event, this.inputs.get());
            }
        };
    },
    onDragEnd: function onDragEnd(item) {
        return function (event) {
            event.stopPropagation();
            if (event.dataTransfer && event.dataTransfer.dropEffect === "none") this.inputs.get().dragndrop.onCancel(item, event, this.inputs.get());
        };
    }
};

var wrapEvents = function wrapEvents() {
    var _this = this;

    return _extends({}, this.inputs.get().dragndrop, {
        onDrag: function onDrag(target, event, inputs) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(_this.inputs.get().selection).contains(target)) {
                _this.onSelect(target, inputs.ancestors, inputs.neighbours);
            }

            _this.outputs.onDrag && _this.outputs.onDrag(target, event, inputs);
        },
        onOver: function onOver(target, event, inputs) {
            _this.outputs.onOver && _this.outputs.onOver(target, event, inputs);
        },
        onEnter: function onEnter(target, event, inputs) {
            _this.outputs.onEnter && _this.outputs.onEnter(target, event, inputs);
        },
        onLeave: function onLeave(target, event, inputs) {
            _this.outputs.onLeave && _this.outputs.onLeave(target, event, inputs);
        },
        onDrop: function onDrop(target, event, inputs) {
            event.preventDefault();
            _this.outputs.onDrop && _this.outputs.onDrop(target, event, inputs);
        },
        onCancel: function onCancel(target, event, inputs) {
            event.preventDefault();
            if (event.dataTransfer && event.dataTransfer.dropEffect === "none") _this.outputs.onCancel && _this.outputs.onCancel(target, event, inputs);
        }
    });
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectionStrategies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickStrategies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return foldStrategies; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools__ = __webpack_require__(1);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var singleSelect = function singleSelect(item, selection, neighbours, ancestors) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(selection).contains(item) ? [] : [item];
};
var multiSelect = function multiSelect(item, selection, neighbours, ancestors) {
    var alreadySelected = false;
    var newSelection = selection.filter(function (i) {
        // Mark if the item was already selected
        if (!alreadySelected) alreadySelected = i === item;
        // Deselect all ancestors
        return i !== item && ancestors.indexOf(i) < 0;
    });
    // Categories : deselect all children
    if (!alreadySelected && item[this.inputs.get().category] && item[this.inputs.get().category] instanceof Array) {
        Object(__WEBPACK_IMPORTED_MODULE_0__tools__["tree"])(item[this.inputs.get().category], this.inputs.get().category).visit(function (children) {
            newSelection = Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(newSelection).notIn(children);
        });
    }
    if (!alreadySelected) newSelection.push(item);
    return newSelection;
};

// Selection strategies are triggered when the selection is updated.
var selectionStrategies = {
    // The single strategy allows only one selected item at the same time (usually the last item clicked).
    single: singleSelect,
    // The multiple strategy allows any number of selected items and will add the last item clicked to the selection list.
    multiple: multiSelect,
    /*
    The modifiers strategy is the way most file explorers behave.
    Without keyboard modifiers, only one selected item is allowed.
    While pressing the shift key, all items between the two last selected siblings are added to the selection array.
    While pressing the ctrl (or cmd for mac users) key, the item is added to the selection list.
     */
    modifiers: function modifiers(item, selection, neighbours, ancestors) {
        var _this = this;

        if (this.modifiers.control || this.modifiers.meta) {
            this.lastSelection = item;
            delete this.lastIndex;
            delete this.lastPivot;
            return multiSelect.bind(this)(item, selection, neighbours, ancestors);
        } else if (this.modifiers.shift) {
            if (!this.lastSelection) return selection;

            var originIndex = neighbours.indexOf(this.lastSelection);
            if (originIndex < 0) return selection;

            var newSelection = selection.slice();
            var endIndex = neighbours.indexOf(item);

            if (originIndex >= 0) {
                var _newSelection;

                if (this.lastPivot) {
                    var lastIndex = neighbours.indexOf(this.lastPivot);

                    var _ref = originIndex > lastIndex ? [lastIndex, originIndex] : [originIndex, lastIndex],
                        _ref2 = _slicedToArray(_ref, 2),
                        _smaller = _ref2[0],
                        _higher = _ref2[1];

                    var deletions = neighbours.slice(_smaller, _higher + 1);
                    newSelection = Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(newSelection).notIn(deletions);
                }
                this.lastPivot = item;

                var _ref3 = originIndex > endIndex ? [endIndex, originIndex] : [originIndex, endIndex],
                    _ref4 = _slicedToArray(_ref3, 2),
                    smaller = _ref4[0],
                    higher = _ref4[1];

                var additions = !this.inputs.get().disabled ? neighbours.slice(smaller, higher + 1) : neighbours.slice(smaller, higher + 1).filter(function (i) {
                    return !_this.inputs.get().disabled(i);
                });
                newSelection = Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(newSelection).notIn(additions);
                (_newSelection = newSelection).push.apply(_newSelection, _toConsumableArray(additions));
            }

            return newSelection;
        } else {
            this.lastSelection = item;
            delete this.lastIndex;
            delete this.lastPivot;
            return singleSelect.bind(this)(item, selection.length > 1 ? [] : selection, neighbours, ancestors);
        }
    },
    // Selects an item and its ancestors.
    ancestors: function (_ancestors) {
        function ancestors(_x, _x2, _x3, _x4) {
            return _ancestors.apply(this, arguments);
        }

        ancestors.toString = function () {
            return _ancestors.toString();
        };

        return ancestors;
    }(function (item, selection, neighbours, ancestors) {
        return selection.length === 0 ? [item] : Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(selection).contains(item) ? [].concat(_toConsumableArray(ancestors)) : [].concat(_toConsumableArray(ancestors), [item]);
    })

    // Click strategies are triggered on item click
};var clickStrategies = {
    // Unfold an item when selecting it. Pair it with the "opener-control" fold strategy.
    "unfold-on-selection": function unfoldOnSelection(item) {
        if (!this.isSelected(item)) {
            var newUnfolded = this.state.get().unfolded.filter(function (i) {
                return i !== item;
            });
            newUnfolded.push(item);
            this.state.set({ unfolded: newUnfolded });
        }
    },
    // Toggle fold/unfold. Pair it with the "opener-control" fold strategy.
    "toggle-fold": function toggleFold(item) {
        var newUnfolded = this.state.get().unfolded.filter(function (i) {
            return i !== item;
        });
        if (newUnfolded.length === this.state.get().unfolded.length) {
            newUnfolded.push(item);
        }
        this.state.set({ unfolded: newUnfolded });
    }

    // Fold strategies determine if an item will be folded or not, meaning if its children are hidden.
};var foldStrategies = {
    // Allow the opener (usually an arrow-like element) to control the fold state.
    "opener-control": function openerControl(item) {
        return !Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(this.state.get().unfolded).contains(item);
    },
    // Fold when not selected.
    "not-selected": function notSelected(item) {
        return !this.isSelected(item);
    },
    // Unfold as long as there is at least one child selected.
    "no-child-selection": function noChildSelection(item) {
        var _this2 = this;

        // naive algorithm ...
        var recurseCheck = function recurseCheck(node) {
            return _this2.isSelected(node) || node[_this2.inputs.get().category] && node[_this2.inputs.get().category] instanceof Array && node[_this2.inputs.get().category].some(recurseCheck);
        };
        return !recurseCheck(item);
    },
    // Fold every item deeper than then "max-depth" component property.
    "max-depth": function maxDepth() {
        return this.inputs.get().maxDepth && !isNaN(parseInt(this.inputs.get().maxDepth, 10)) ? this.inputs.get().depth >= parseInt(this.inputs.get().maxDepth, 10) : false;
    }
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaults; });
var defaults = {
    labels: {
        "search.placeholder": "Search ..."
    },
    css: {
        TreeView: "TreeView",
        opener: "opener",
        depth: "depth",
        selected: "selected",
        category: "category",
        folded: "folded",
        disabled: "disabled",
        async: "async",
        loading: "loading",
        nodrop: "nodrop",
        dragover: "dragover",
        search: "search",
        item: "item"
    },
    strategies: {
        selection: ["single"],
        click: [],
        fold: ["not-selected", "no-child-selection"]
    },
    display: function display(_) {
        return _.toString();
    },
    async: function async(_) {
        return _();
    },
    noOpener: false,
    dragndrop: {
        draggable: false,
        droppable: false
    }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixins = __webpack_require__(0);

Object.keys(_mixins).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mixins[key];
    }
  });
});

__webpack_require__(12);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var optsMixin = exports.optsMixin = function optsMixin() {
    var argument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "opts";
    return {
        init: function init() {
            this.on("update", this.updateOpts);
            this._originalOpts = Object.keys(this.opts);
            this.updateOpts();
        },
        updateOpts: function updateOpts() {
            if (!this.opts) return;
            for (var key in this.opts[argument]) {
                if (!~this._originalOpts.indexOf(key)) this.opts[key] = this.opts[argument][key];
            }
        }
    };
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var transitionMixin = exports.transitionMixin = function transitionMixin(nodeTarget) {
    return {
        init: function init() {
            var _this = this;

            if (!this.opts.transition) return;
            var transitionName = this.opts.transition.name;
            var origUnmount = this.unmount;

            var mountTransition = function mountTransition() {
                var target = (nodeTarget || function () {
                    return _this.root;
                })();
                if (!target) return;

                target.classList.add(transitionName);
                target.classList.add(transitionName + "-mount");
                setTimeout(function () {
                    target.classList.remove(transitionName + "-mount");
                }, 10);
            };

            var guard = false;
            var unmountTransition = function unmountTransition() {
                if (guard) return;
                guard = true;
                var target = (nodeTarget || function () {
                    return _this.root;
                })();
                if (!target) return origUnmount.call(_this);

                target.addEventListener("transitionend", function () {
                    origUnmount.call(_this);
                });
                target.classList.add(transitionName + "-unmount");
            };

            this.one("mount", mountTransition);
            Object.defineProperty(this, "unmount", {
                value: unmountTransition
            });
        }
    };
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var listenerMixin = exports.listenerMixin = function listenerMixin(_ref) {
    var _ref$eventType = _ref.eventType,
        eventType = _ref$eventType === undefined ? "click" : _ref$eventType,
        callback = _ref.callback,
        _ref$regulate = _ref.regulate,
        regulate = _ref$regulate === undefined ? false : _ref$regulate;
    return {
        init: function init() {
            var ticking = false;

            var onEvent = function onEvent(event) {
                if (callback) {
                    if (regulate) {
                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                return callback(event, function () {
                                    return ticking = false;
                                });
                            });
                        }
                        ticking = true;
                    } else callback(event);
                }
            };
            this.one("mount", function () {
                document.addEventListener(eventType, onEvent);
            });
            this.one("unmount", function () {
                document.removeEventListener(eventType, onEvent);
            });
        }
    };
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);

__webpack_require__(21);

__webpack_require__(22);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(2)
    riot.tag2('treeview', '<div class="{rootNode.mixCss(⁗TreeView⁗)}"> <input type="search" class="{rootNode.mixCss(⁗search⁗)}" if="{inputs.get().search}" placeholder="{inputs.get().labels[⁗search.placeholder⁗]}" oninput="{onSearch}"> <treeviewnode opts="{inputs.get()}" selection="{opts.selection}" model="{inputs.get().sort ? inputs.get().model.sort(inputs.get().sort) : inputs.get().model}" filteredmodel="{filtered}" onselection="{rootNode.onSelect}" dragndrop="{rootNode.wrapDragNDrop()}" ancestors="{[]}" searched="{search.trim()}" depth="{0}"> </TreeViewNode> </div>', '', '', function(opts) {
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _tools = __webpack_require__(1);

var _core = __webpack_require__(4);

var _mixins = __webpack_require__(0);

this.mixin((0, _mixins.optsMixin)());
this.mixin((0, _mixins.listenerMixin)({ eventType: "keyup", callback: function callback(e) {
        return _this.rootNode.onKey(e);
    } }));
this.mixin((0, _mixins.listenerMixin)({ eventType: "keydown", callback: function callback(e) {
        return _this.rootNode.onKey(e);
    } }));

// Logic //

this.filtered = null;
this.search = "";

this.onSearch = function (evt) {
    var input = evt.currentTarget.value;
    _this.search = input;
    _this.filtered = !input.trim() ? null : (0, _tools.tree)(_this.inputs.get().model, _this.inputs.get().category).treeFilter(_this.inputs.get().search(input.trim()));
};

// Boilerplate //

this.inputs = {
    get: function get() {
        return _extends({}, _core.defaults, _this.opts, {
            onSelect: _this.opts.onselection
        });
    }
};
this.outputs = {
    onSelect: this.inputs.get().onselection,
    onDrag: this.inputs.get().dragndrop && this.inputs.get().dragndrop.drag,
    onOver: this.inputs.get().dragndrop && this.inputs.get().dragndrop.over,
    onEnter: this.inputs.get().dragndrop && this.inputs.get().dragndrop.enter,
    onLeave: this.inputs.get().dragndrop && this.inputs.get().dragndrop.leave,
    onDrop: this.inputs.get().dragndrop && this.inputs.get().dragndrop.drop,
    onCancel: this.inputs.get().dragndrop && this.inputs.get().dragndrop.cancel
};
this.state = {
    get: function get() {
        return _extends({}, _this);
    },
    set: function set(s) {
        for (var key in s) {
            if (key in _this) _this[key] = s[key];
        }
    }
};

this.rootNode = new _core.RootNode(this.inputs, this.outputs, this.state, this.update);
});

    
  

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tree; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrays__ = __webpack_require__(3);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var tree = function tree(t, prop) {
    return {
        flatten: function flatten() {
            var flattened = [];
            var fifo = [t];
            while (fifo.length > 0) {
                var _tree = fifo.pop();
                if (!(_tree instanceof Array)) continue;
                flattened = [].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0__arrays__["a" /* array */])(flattened).notIn(_tree)), _toConsumableArray(_tree));
                fifo = [].concat(_toConsumableArray(fifo), _toConsumableArray(_tree.filter(function (item) {
                    return item[prop];
                }).map(function (item) {
                    return item[prop];
                })));
            }

            return flattened;
        },
        filter: function filter(filterFun) {
            var copy = t.filter(filterFun);
            var recurse = function recurse(list) {
                list.forEach(function (item) {
                    if (item[prop] && item[prop] instanceof Array) {
                        item[prop] = item[prop].filter(filterFun);
                        recurse(item[prop]);
                    }
                });
            };
            recurse(copy);
            return copy;
        },
        treeFilter: function treeFilter(filterFun) {
            var finalMap = new Map();

            var recurse = function recurse(list, map) {
                list.forEach(function (item) {
                    if (item[prop] && item[prop] instanceof Array) {
                        var childMap = new Map();
                        recurse(item[prop], childMap);
                        if (childMap.size > 0) {
                            map.set(item, childMap);
                        } else if (filterFun(item)) {
                            map.set(item, new Map());
                        }
                    } else if (filterFun(item)) {
                        map.set(item, null);
                    }
                });
            };
            recurse(t, finalMap);
            return finalMap;
        },
        add: function add(parent, elt) {
            var fifo = [t];
            while (fifo.length > 0) {
                var _tree2 = fifo.pop();
                var idx = _tree2.indexOf(parent);
                if (idx >= 0 && _tree2[idx][prop]) {
                    _tree2[idx][prop] = _tree2[idx][prop].slice();
                    _tree2[idx][prop].push(elt);
                    return t;
                }
                fifo = [].concat(_toConsumableArray(fifo), _toConsumableArray(_tree2.filter(function (item) {
                    return item[prop];
                }).map(function (item) {
                    return item[prop];
                })));
            }
            return t;
        },
        visit: function visit(visitor) {
            var fifo = [t];
            while (fifo.length > 0) {
                var _tree3 = fifo.pop();
                visitor(_tree3);
                _tree3.forEach(function (child) {
                    return child[prop] && child[prop] instanceof Array ? fifo.push(child[prop]) : null;
                });
            }
        }
    };
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return string; });
var string = function string(str) {
    return {
        contains: function contains(input) {
            return !!str && !!str.match(new RegExp(".*" + input + ".*", "gi"));
        }
    };
};

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deepMix; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var deepMix = function deepMix(one, two) {
    var mergeArrays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!one || !two || (typeof one === "undefined" ? "undefined" : _typeof(one)) !== "object" || (typeof two === "undefined" ? "undefined" : _typeof(two)) !== "object") return one;

    var clone = _extends({}, one, two);
    for (var prop in two) {
        if (two.hasOwnProperty(prop)) {
            if (two[prop] instanceof Array && one[prop] instanceof Array) {
                clone[prop] = mergeArrays ? [].concat(_toConsumableArray(one[prop]), _toConsumableArray(two[prop])) : clone[prop] = two[prop];
            } else if (_typeof(two[prop]) === "object" && _typeof(one[prop]) === "object") {
                clone[prop] = deepMix(one[prop], two[prop], mergeArrays);
            }
        }
    }

    return clone;
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
var css = {
    classes: function classes(_classes) {
        var css = [];
        for (var _key in _classes) {
            if (_classes[_key]) {
                css.push(_key);
            }
        }
        return css.join(" ");
    },
    addClass: function addClass(elt, cname) {
        if (elt instanceof HTMLElement) elt.className = elt.className.split(" ").filter(function (c) {
            return c !== cname;
        }).join(" ") + " " + cname;
    },
    removeClass: function removeClass(elt, cname) {
        if (elt instanceof HTMLElement) elt.className = elt.className.split(" ").filter(function (c) {
            return c !== cname;
        }).join(" ");
    },
    hasClass: function hasClass(elt, cname) {
        return elt instanceof HTMLElement ? elt.className.indexOf(cname) >= 0 : false;
    }
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return printer; });
var printer = {
    debug: function debug(title, msg /* eslint-enable */) {
        var logger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;

        var headerStyle = "background-color: red; color: white; font-size: 1.1em; font-weight: bold; padding: 3px 10px; border-radius: 5px";
        var titleStyle = "color: #444; font-weight: bold; font-size: 1.1em";
        var msgStyle = "color: #222; font-weight: bold";

        logger("%cDEBUG%c " + title, headerStyle, titleStyle);
        logger("%c" + msg, msgStyle);
    }
};

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return object; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var object = function object(self) {
    if (!self || !(self instanceof Object)) {
        throw new Error("Bad object format");
    }

    return {
        shallowCompare: function shallowCompare(obj, excludes) {
            var equals = true;
            for (var key in self) {
                if (self.hasOwnProperty(key)) {
                    if (!(excludes && excludes.indexOf(key) >= 0) && obj[key] !== self[key]) {
                        equals = false;
                        return;
                    }
                }
            }
            return equals;
        },
        filter: function filter(fun) {
            var copy = {};
            for (var prop in self) {
                if (self.hasOwnProperty(prop) && fun(self[prop])) copy[prop] = self[prop];
            }
            return copy;
        },
        map: function map(fun) {
            var copy = {};
            for (var prop in self) {
                if (self.hasOwnProperty(prop)) copy[prop] = fun(self[prop]);
            }
            return copy;
        },
        fullMap: function fullMap(fun) {
            var copy = {};
            for (var prop in self) {
                if (self.hasOwnProperty(prop)) {
                    var _fun = fun(prop, self[prop]),
                        _fun2 = _slicedToArray(_fun, 2),
                        newProp = _fun2[0],
                        newVal = _fun2[1];

                    copy[newProp] = newVal;
                }
            }
            return copy;
        },
        nestPrefix: function nestPrefix(prefix) {
            var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_) {
                return _;
            };

            var copy = _defineProperty({}, prefix, {});
            for (var prop in self) {
                if (self.hasOwnProperty(prop) && prop.startsWith(prefix)) {
                    copy[prefix][transform(prop.substring(prefix.length))] = self[prop];
                } else {
                    copy[prop] = self[prop];
                }
            }
            return copy;
        }
    };
};

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TreeNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RootNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dragndrop__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strategies__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaults__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






// * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * //
//  Boilerplate  for framework class adapters

var Core = function Core(inputs, outputs, state, refresh) {
    _classCallCheck(this, Core);

    this.inputs = inputs;
    this.outputs = outputs;
    this.state = state;
    this.refresh = refresh;
};

// * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * //
// Tree node

var TreeNode = function (_Core) {
    _inherits(TreeNode, _Core);

    function TreeNode() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TreeNode);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call.apply(_ref, [this].concat(args))), _this), _this.isSelected = function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__tools__["array"])(_this.inputs.get().selection).contains(item);
        }, _this.isFolded = function (item) {
            var strats = _this.inputs.get().strategies;
            return (!_this.inputs.get().searched || _this.isAsync(item)) && (strats && strats.fold || []).map(function (strat) {
                return (__WEBPACK_IMPORTED_MODULE_2__strategies__["b" /* foldStrategies */][strat] || strat).bind(_this);
            }).reduce(function (last, curr) {
                return last && curr(item, last);
            }, true);
        }, _this.hasChildren = function (item) {
            return item[_this.inputs.get().category] && item[_this.inputs.get().category] instanceof Array;
        }, _this.isAsync = function (item) {
            return !!item && [_this.inputs.get().category] && typeof item[_this.inputs.get().category] === "function";
        }, _this.isDisabled = function (item) {
            var disabledFun = _this.inputs.get().disabled;
            return disabledFun ? disabledFun(item) : false;
        }, _this.isDraggable = function (item) {
            return item && _this.inputs.get().dragndrop.draggable && (typeof _this.inputs.get().dragndrop.draggable === "function" ? _this.inputs.get().dragndrop.draggable(item) : true);
        }, _this.isDroppable = function (item) {
            return _this.inputs.get().dragndrop.droppable && (typeof _this.inputs.get().dragndrop.droppable === "function" ? _this.inputs.get().dragndrop.droppable(item) : true);
        }, _this.mixCss = function (prop) {
            return _this.inputs.get().css[prop] || __WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* defaults */].css[prop];
        }, _this.ulCss = function () {
            return __WEBPACK_IMPORTED_MODULE_0__tools__["css"].classes(_defineProperty({}, _this.mixCss("depth") + "-" + (_this.inputs.get().depth || 0), true));
        }, _this.liCss = function (item) {
            var _css$classes2;

            return __WEBPACK_IMPORTED_MODULE_0__tools__["css"].classes((_css$classes2 = {}, _defineProperty(_css$classes2, _this.mixCss("selected"), _this.isSelected(item)), _defineProperty(_css$classes2, _this.mixCss("category"), _this.hasChildren(item) || _this.isAsync(item)), _defineProperty(_css$classes2, _this.mixCss("folded"), _this.hasChildren(item) || _this.isAsync(item) ? _this.isFolded(item) : null), _defineProperty(_css$classes2, _this.mixCss("disabled"), _this.isDisabled(item)), _defineProperty(_css$classes2, _this.mixCss("async"), _this.isAsync(item) && _this.isFolded(item)), _defineProperty(_css$classes2, _this.mixCss("loading"), _this.isAsync(item) && !_this.isFolded(item)), _css$classes2));
        }, _this.pending = [], _this.unwrapPromise = function (item) {
            _this.pending.push(item);
            var asyncFun = _this.inputs.get().async;
            if (!asyncFun) return Promise.reject(new Error("Missing async function."));else return asyncFun(item[_this.inputs.get().category]).then(function (res) {
                item[_this.inputs.get().category] = res;
                _this.refresh();
            }).catch(function (err) {
                /* eslint-disable */
                throw err;
                /* eslint-enable */
            }).then(function () {
                return _this.pending = _this.pending.filter(function (e) {
                    return e !== item;
                });
            });
        }, _this.onClick = function (item) {
            return function (event) {
                if (_this.isDisabled(item)) return;
                var strats = _this.inputs.get().strategies;
                (strats && strats.click || []).map(function (strat) {
                    return (__WEBPACK_IMPORTED_MODULE_2__strategies__["a" /* clickStrategies */][strat] || strat).bind(_this);
                }).forEach(function (strat) {
                    return strat(item, event, _this.inputs.get().ancestors, _this.inputs.get().model);
                });
                _this.inputs.get().onSelect(item, _this.inputs.get().ancestors, _this.inputs.get().model);
                event.stopPropagation();
            };
        }, _this.getDragEvents = function (item) {
            var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!condition) return {};
            var result = {
                draggable: _this.isDraggable(item),
                onDragStart: _this.isDraggable(item) && __WEBPACK_IMPORTED_MODULE_1__dragndrop__["b" /* nodeEvents */].onDragStart(item).bind(_this),
                onDragOver: _this.isDroppable(item) && __WEBPACK_IMPORTED_MODULE_1__dragndrop__["b" /* nodeEvents */].onDragOver(item).bind(_this),
                onDragEnter: _this.isDroppable(item) && __WEBPACK_IMPORTED_MODULE_1__dragndrop__["b" /* nodeEvents */].onDragEnter(item).bind(_this),
                onDragLeave: _this.isDroppable(item) && __WEBPACK_IMPORTED_MODULE_1__dragndrop__["b" /* nodeEvents */].onDragLeave(item).bind(_this),
                onDrop: _this.isDroppable(item) && __WEBPACK_IMPORTED_MODULE_1__dragndrop__["b" /* nodeEvents */].onDrop(item).bind(_this),
                onDragEnd: _this.isDraggable(item) && __WEBPACK_IMPORTED_MODULE_1__dragndrop__["b" /* nodeEvents */].onDragEnd(item).bind(_this)
            };
            for (var _key2 in result) {
                if (!result[_key2]) delete result[_key2];
            }return result;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /* Various checks */

    /* Styles calculation */

    // Css mixin helper


    /* Promises */

    // Pending promises


    // Unwrap a promise and mutate the model to add the results


    /* Events */

    // On item click


    _createClass(TreeNode, [{
        key: "onOpener",


        // On opener click
        value: function onOpener(item) {
            var _this2 = this;

            return function (event) {
                var newVal = _this2.state.get().unfolded.filter(function (i) {
                    return i !== item;
                });
                if (newVal.length === _this2.state.get().unfolded.length) newVal.push(item);
                _this2.state.set({ unfolded: newVal });
                event.stopPropagation();
            };
        }

        // Drag'n'drop //

    }]);

    return TreeNode;
}(Core);

// * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * //
// Root node of the tree

var RootNode = function (_Core2) {
    _inherits(RootNode, _Core2);

    function RootNode() {
        var _ref2;

        var _temp2, _this3, _ret2;

        _classCallCheck(this, RootNode);

        for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = RootNode.__proto__ || Object.getPrototypeOf(RootNode)).call.apply(_ref2, [this].concat(args))), _this3), _this3.modifiers = {}, _this3.onKey = function (event) {
            _this3.modifiers = {
                control: event.getModifierState("Control"),
                meta: event.getModifierState("Meta"),
                shift: event.getModifierState("Shift")
            };
        }, _this3.onSelect = function (item, ancestors, neighbours) {
            var selectionStrategy = _this3.inputs.get().strategies.selection || [];
            var newSelection = selectionStrategy.map(function (strat) {
                return (__WEBPACK_IMPORTED_MODULE_2__strategies__["c" /* selectionStrategies */][strat] || strat).bind(_this3);
            }).reduce(function (last, curr) {
                return curr(item, last, neighbours, ancestors);
            }, _this3.inputs.get().selection);
            _this3.outputs.onSelect(newSelection, item, ancestors, neighbours);
            return newSelection;
        }, _this3.wrapDragNDrop = __WEBPACK_IMPORTED_MODULE_1__dragndrop__["d" /* wrapEvents */].bind(_this3), _this3.mixCss = function (prop) {
            return _this3.inputs.get().css[prop] || __WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* defaults */].css[prop];
        }, _this3.filterTree = function (input) {
            var search = _this3.inputs.get().search;
            return !search ? null : !input.trim() ? null : Object(__WEBPACK_IMPORTED_MODULE_0__tools__["tree"])(_this3.inputs.get().model, _this3.inputs.get().category).treeFilter(search(input.trim()));
        }, _temp2), _possibleConstructorReturn(_this3, _ret2);
    }

    /* Events */

    // Keyboard modifiers list


    // When new element(s) are selected


    // Framework input wrapper


    // Css mixin helper


    // Used to filter the tree when performing a search


    return RootNode;
}(Core);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


    var riot = __webpack_require__(2)
    riot.tag2('treeviewnode', '<ul if="{!opts.folded && !opts.loading}" data-is="with-transition" transition="{opts.transition}" class="{node.ulCss()}" ondragover="{!opts.depth ? rootEvents.onDragOver : null}" ondragenter="{!opts.depth ? rootEvents.onDragEnter : null}" ondragleave="{!opts.depth ? rootEvents.onDragLeave : null}" ondrop="{!opts.depth ? rootEvents.onDrop : null}"> <li each="{item in getModel()}" class="{node.liCss(item)}" draggable="{node.getDragEvents(item).draggable}" ondragstart="{node.getDragEvents(item).onDragStart}" ondragover="{node.getDragEvents(item).onDragOver}" ondragenter="{node.getDragEvents(item).onDragEnter}" ondragleave="{node.getDragEvents(item).onDragLeave}" ondragend="{node.getDragEvents(item).onDragEnd}" ondrop="{node.getDragEvents(item).onDrop}"> <span class="{parent.node.mixCss(⁗item⁗)}" onclick="{parent.node.onClick(item)}"> <virtual if="{!parent.opts.displaytag}"> {parent.opts.display(item, parent.opts)} </virtual> <virtual if="{parent.opts.displaytag}" data-is="{parent.opts.displaytag(item, parent.opts)}" item="{item}" inputs="{inputs.get()}"></virtual> <span if="{node.hasChildren(item) || node.isAsync(item) && !parent.opts.noopener}" class="{node.mixCss(⁗opener⁗)}" onclick="{node.onOpener(item)}"></span> </span> <treeviewnode if="{node.hasChildren(item) || node.isAsync(item)}" opts="{parent.opts}" selection="{parent.opts.selection}" model="{getChildModel(item)}" filteredmodel="{getChildFiltered(item)}" ancestors="{getAncestors(item)}" depth="{parent.opts.depth + 1}" folded="{node.isFolded(item)}" loading="{node.isAsync(item) && !node.isFolded(item)}"> </TreeViewNode> </li> </ul> <span if="{opts.loading}"></span>', '', '', function(opts) {
"use strict";

var _this = this;

var _core = __webpack_require__(4);

var _mixins = __webpack_require__(0);

this.mixin((0, _mixins.optsMixin)());

// Logic //

this.unfolded = [];

this.getModel = function () {
    return _this.opts.searched ? _this.opts.model.filter(function (m) {
        return _this.opts.filteredmodel.has(m);
    }) : _this.opts.model;
};

this.getChildModel = function (item) {
    var childModel = item[_this.opts.category];

    /* If data has to be retrieved asynchronously */
    if (_this.node.isAsync(item) && !_this.node.isFolded(item) && _this.node.pending.indexOf(item) < 0) {
        _this.node.unwrapPromise(item);
    }
    if (!_this.node.isAsync(item)) {
        childModel = _this.opts.sort ? childModel.sort(_this.opts.sort) : childModel;
    }

    return childModel;
};

this.getChildFiltered = function (item) {
    return _this.opts.searched ? _this.opts.filteredmodel.get(item) : null;
};

this.getAncestors = function (item) {
    return [].concat(_this.opts.ancestors, [item]);
};

// Boilerplate //

var mock = function mock() {
    _this.opts.onSelect = _this.opts.onselection;
    _this.opts.disabled = _this.opts.disable;
};
this.on("update", mock);
mock();

this.inputs = { get: function get() {
        return _this.opts;
    } };
this.state = {
    get: function get() {
        return _this;
    },
    set: function set(s) {
        for (var key in s) {
            if (key in _this) _this[key] = s[key];
        }
    }
};
this.node = new _core.TreeNode(this.inputs, null, this.state, this.update);
this.rootEvents = this.node.getDragEvents();
});

    
  

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _riot = __webpack_require__(2);

var _riot2 = _interopRequireDefault(_riot);

var _mixins = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _riot2.default.tag("with-transition", false, function (opts) {
    var _this = this;

    this.mixin((0, _mixins.transitionMixin)());
    var updateKeys = function updateKeys() {
        for (var key in _this.parent) {
            if (_this.parent.hasOwnProperty(key)) _this[key] = _this.parent[key];
        }
    };
    updateKeys();
    this.on("update", updateKeys);
});

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// build/riot/index.js